<template>
  <CHeaderNav class="d-md-down-none mr-auto">
    <CHeaderNavItem v-for="n in nav" v-bind:key="n.name">
      <CHeaderNavLink v-if="n._name == 'CSidebarNavItem'" :href="'#' + n.href">
        {{ n.name }}
      </CHeaderNavLink>
      <CDropdown
        v-if="n._name == 'CSidebarNavDropdown'"
        color="link"
        :caret="false"
      >
        <template #toggler-content>
          <a class="c-header-nav-link">
            {{ n.name }}
          </a>
        </template>
        <CDropdownItem
          v-for="d in n._children"
          v-bind:key="d.name"
          :href="'#' + d.to"
        >
          {{ d.name }}
        </CDropdownItem>
      </CDropdown>

      
      
    </CHeaderNavItem>
<CDropdown
       
        color="link"
        :caret="false"
      >
        <template #toggler-content>
          <a class="c-header-nav-link">
            {{getCurrentLanguage.lang}}
          </a>
        </template>
        <CDropdownItem @click="changeLanguage('fr')">
          {{ $t("Languages.fr") }}
        </CDropdownItem>
        <CDropdownItem @click="changeLanguage('en')">
          {{ $t("Languages.en") }}
        </CDropdownItem>
        <CDropdownItem @click="changeLanguage('ar')">
          {{ $t("Languages.ar") }}
        </CDropdownItem>
      </CDropdown>

  </CHeaderNav>
</template>

<script>
import axios from "axios";
export default {
  name: "Menu",
  data() {
    return {
      //minimize: false,
      nav: [],
      //show: true,
      buffor: [],
    };
  },
  methods: {
    changeLanguage(locale) {
      this.$loading.show()
      this.$i18n.locale = locale;
      localStorage.setItem('Language', locale);
      location.reload(true);
    },
    dropdown(data) {
      let result = {
        _name: "CSidebarNavDropdown",
        name: data["name"],
        route: data["href"],
        icon: data["icon"],
        _children: [],
      };
      for (let i = 0; i < data["elements"].length; i++) {
        if (data["elements"][i]["slug"] == "dropdown") {
          result._children.push(this.dropdown(data["elements"][i]));
        } else {
          result._children.push({
            _name: "CSidebarNavItem",
            name: data["elements"][i]["name"],
            to: data["elements"][i]["href"],
            icon: data["elements"][i]["icon"],
          });
        }
      }
      return result;
    },
    rebuildData(data) {
      this.buffor = [];
      for (let k = 0; k < data.length; k++) {
        switch (data[k]["slug"]) {
          case "link":
            if (data[k]["href"].indexOf("http") !== -1) {
              this.buffor.push({
                _name: "CSidebarNavItem",
                name: data[k]["name"],
                href: data[k]["href"],
                icon: data[k]["icon"],
                target: "_blank",
              });
            } else {
              this.buffor.push({
                _name: "CSidebarNavItem",
                name: data[k]["name"],
                to: data[k]["href"],
                icon: data[k]["icon"],
              });
            }
            break;
          case "title":
            this.buffor.push({
              _name: "CSidebarNavTitle",
              _children: [data[k]["name"]],
            });
            break;
          case "dropdown":
            this.buffor.push(this.dropdown(data[k]));
            break;
        }
      }
      return this.buffor;
    },
  },
  mounted() {
    let self = this;
    console.log(this.$apiAdress);
    axios
      .get(
        this.$apiAdress +
          "/api/menu?token=" +
          localStorage.getItem("api_token") +
          "&menu=" +
          "top_menu"
      )
      .then(function(response) {
        self.nav = self.rebuildData(response.data);
      })
      .catch(function(error) {
        console.log(error);
        self.$router.push({ path: "/login" });
      });
  },
  computed: {
    getCurrentLanguage() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { lang: "English" };
      else if (locale == "fr") return { lang: "Français" };
      else if (locale == "es") return { lang: "Española" };
      else if (locale == "pt") return { lang: "Portugues" };
      else if (locale == "de") return { lang: "Deutsche" };
      else if (locale == "ru") return { lang: "Русский" };
      else if (locale == "ar") return { lang: "العريية" };
      else if (locale == "he") return { lang: "עברי" };
      return this.locale;
    },
  }
};
</script>
